import styled from '@emotion/styled';
import { ArrowLink } from '../Link';
import Responsive from '../../utils/Responsive';

export const StyledCardLink = styled(ArrowLink)`
	@media (${Responsive.getMediaQueryForBreakpoint('mobile')}) {
		font-size: 16px;
	}
`;
